import { useParams } from 'react-router-dom';
import CertificateDownloadBox from '../components/CertificateDownloadBox';

export default function ThankYou() {
  const { orderId, stoneId } = useParams();
  return (
    <>
      <div className="container pt-5 pb-3 text-center">
        <h1>Download your certificate</h1>
      </div>

      <div className="bg-light">
        <div className="container pt-4 pb-1">
          <CertificateDownloadBox stoneId={stoneId} orderId={orderId} />
        </div>
      </div>
    </>
  );
}
